import { ITipoPessoaEnum } from '../../../../models/happy-code-api.model';
import { formatCnpj, formatCpf } from '../../../../util/format';

export default function useInputHook() {
	const verifyMaxLength = (tipoPessoa: ITipoPessoaEnum): number => {
		if (tipoPessoa === 'Física' || !tipoPessoa) {
			return 14;
		} else {
			return 20;
		}
	};

   function formatarCpfCnpj(value: string) {
    value = value.replace(/\D/g, '');
  
    if (value.length <= 11) {
      value = formatCpf(value);

    } else {
      value = formatCnpj(value);
    }
  
    return value;
  }
  
return { verifyMaxLength, formatarCpfCnpj };
}
